import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { VIDEO_STRIP_CONTAINER } from '../constants';
import { VIDEO_STRIP } from '../../../GigCards/Components/constants';
import { calcVideoStripRow } from './videoStripUtils';

interface VideoStripProps {
    gigs: any[];
    getRenderGig: (gig: any) => React.ReactNode;
    bannersExist: boolean;
    positionRef?: React.RefObject<HTMLDivElement>;
}

export const VideoStrip: React.FC<VideoStripProps> = ({
    gigs,
    getRenderGig,
    bannersExist,
    positionRef,
}: VideoStripProps) => {
    const videoGigs = gigs.filter((gig) => gig.type === VIDEO_STRIP);
    if (!videoGigs.length) {
        return null;
    }
    const videoStripRow = calcVideoStripRow(gigs, bannersExist);

    return (
        <Container ref={positionRef} className={VIDEO_STRIP_CONTAINER} style={{ gridRow: videoStripRow }}>
            {videoGigs.map((gig) => getRenderGig(gig))}
        </Container>
    );
};
